import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Input, Label, Row, Table } from 'reactstrap';
import { IFundingSource } from './FundingSources';

interface IProps {
    fundingSourceItem: IFundingSource
}

export const FundingSourceCard = ({ fundingSourceItem }: IProps) => {
    return (
        <Card className="fundingSourcesCard">
            <CardHeader>
                <Row className="cardHeaderRow">
                    <Col lg={6} md={6} xs={12} className="cardHeaderName">{fundingSourceItem.fundingSourceName}</Col>
                    <Col lg={6} md={6} xs={12} className="cardHeaderAction">
                        {fundingSourceItem.sourceURL ? (
                            <Button className="solidNeg tertiaryButton iconOpenExternal text-nowrap" href={fundingSourceItem.sourceURL} target="_blank">FULL DETAILS</Button>
                        ) : ('')}
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>

            <div className="fundingTable desktopView">
                <Row className="rowHeading">
                        <Col lg={2} md={2} className="columnHeading columnBorder text-left">
                        Administrator
                    </Col>
                        <Col lg={2} md={2} className="columnHeading columnBorder text-left">
                        Funding Type
                    </Col>
                        <Col lg={2} md={3} className="columnHeading columnBorder text-left">
                        Vehicle Categories
                    </Col>
                        <Col lg={2} md={3} className="columnHeading columnBorder text-left">
                        Eligible Costs
                    </Col>
                        <Col lg={4} md={2} className="columnHeading columnBorder text-left">
                        Notes
                    </Col>
                </Row>
                <Row className="rowBody">
                        <Col lg={2} md={2} className="columnBody columnBorder text-left">
                            {fundingSourceItem.administratorName.administratorNames.map((item: string, index: number) => {
                                return (
                                    <p className={item ? '' : 'light'} key={`${item}-${index}`}>{item ? item : 'Not Applicable'}</p>
                                );
                            })}
                    </Col>
                        <Col lg={2} md={2} className="columnBody columnBorder proper-case text-left">
                        {fundingSourceItem.fundingSourceTypeName}
                    </Col>
                        <Col lg={2} md={3} className="columnBody columnBorder badges badgeBackground1">
                        {fundingSourceItem.vehicleCategories.vehicleCategoryNames.map((item: string, index: number) => {
                            return (
                                <Badge className={item ? '' : 'light'} key={`${item}-${index}`}>{item ? item : 'Not Applicable'}</Badge>
                            );
                        })}
                    </Col>
                        <Col lg={2} md={3} className="columnBody columnBorder badges badgeBackground2">
                        {fundingSourceItem.eligibleCostsList.eligibleCosts.map((item: string, index: number) => {
                            return (
                                <Badge className={item ? '' : 'light'} key={`${item}-${index}`}>{item ? item : 'Not Applicable'}</Badge>
                            );
                        })}
                    </Col>
                        <Col lg={4} md={2} className="columnBody columnBorder text-left">
                        <p>{fundingSourceItem.programOfferingDescription}</p>
                        
                        {fundingSourceItem.upcomingDeadlineDescription ? 
                            <p className="notesSecondParagraph text-left"><strong>Upcoming deadlines: </strong>{fundingSourceItem.upcomingDeadlineDescription}</p>
                        : ('')}
                    </Col>
                    </Row>
                </div>

                <div className="fundingTable mobileView">
                    <Row className="rowHeading">
                        <Col xs={4} md={4} className="columnHeading columnBorder text-left">
                            Administrator
                        </Col>
                        <Col xs={8} md={8} className="columnBody columnBorder badges badgeBackground1">
                            {fundingSourceItem.administratorName.administratorNames.map((item: string, index: number) => {
                                return (
                                    <p className={item ? '' : 'light'} key={`${item}-${index}`}>{item ? item : 'Not Applicable'}</p>
                                );
                            })}
                        </Col>
                    </Row>
                        <Row>
                        <Col xs={4} md={4} className="columnHeading columnBorder text-left">
                            Funding Type
                        </Col>
                        <Col xs={8} md={8} className="columnBody columnBorder proper-case">
                            {fundingSourceItem.fundingSourceTypeName}
                        </Col>
                    </Row><Row>
                        <Col xs={4} md={4} className="columnHeading columnBorder text-left">
                            Vehicle Categories
                        </Col>
                        <Col xs={8} md={8} className="columnBody columnBorder badges badgeBackground1">
                            {fundingSourceItem.vehicleCategories.vehicleCategoryNames.map((item: string, index: number) => {
                                return (
                                    <Badge className={item ? '' : 'light'} key={`${item}-${index}`}>{item ? item : 'Not Applicable'}</Badge>
                                );
                            })}
                        </Col>
                        </Row><Row>
                        <Col xs={4} md={4} className="columnHeading columnBorder text-left">
                            Eligible Costs
                        </Col>
                        <Col xs={8} md={8} className="columnBody columnBorder badges badgeBackground2">
                            {fundingSourceItem.eligibleCostsList.eligibleCosts.map((item: string, index: number) => {
                                return (
                                    <Badge className={item ? '' : 'light'} key={`${item}-${index}`}>{item ? item : 'Not Applicable'}</Badge>
                                );
                            })}
                        </Col>
                    </Row><Row>
                        <Col xs={4} md={4} className="columnHeading columnBorder text-left">
                            Notes
                        </Col>
                        <Col xs={8} md={8} className="columnBody columnBorder">
                            <p>{fundingSourceItem.programOfferingDescription}</p>
                            
                            {fundingSourceItem.upcomingDeadlineDescription ?
                                <p className="notesSecondParagraph"><strong>Upcoming deadlines: </strong>{fundingSourceItem.upcomingDeadlineDescription}</p>
                                : ('')}
                        </Col>
                    </Row>
                </div>

            </CardBody>
        </Card>
    )
};